function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoa1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5000px",
    height: "634px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d4011b",
    d: "M 4320.5,0.5 C 4325.62,0.530513 4330.62,1.36385 4335.5,3C 4432.33,29.9402 4526.66,63.6069 4618.5,104C 4585.46,113.512 4552.46,123.345 4519.5,133.5C 4425.46,89.0933 4328.46,52.2599 4228.5,23C 4259,14.5412 4289.67,7.04123 4320.5,0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d4011b",
    d: "M 4174.5,36.5 C 4176.86,36.3367 4179.19,36.5034 4181.5,37C 4279.86,67.0239 4375.2,104.524 4467.5,149.5C 4435.3,160.598 4403.3,172.265 4371.5,184.5C 4275.45,138.647 4176.45,100.314 4074.5,69.5C 4107.67,57.6648 4141,46.6648 4174.5,36.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0052c1",
    d: "M 4100.5,111.5 C 4109.5,115.276 4118.83,118.276 4128.5,120.5C 4145.17,125.446 4161.51,131.279 4177.5,138C 4113.14,160.952 4050.14,187.118 3988.5,216.5C 3981.74,218.712 3975.41,221.712 3969.5,225.5C 3967.15,227.341 3964.48,228.674 3961.5,229.5C 3952.69,233.072 3944.35,237.405 3936.5,242.5C 3906.24,258.632 3876.24,275.298 3846.5,292.5C 3812.59,278.697 3778.59,265.197 3744.5,252C 3754.54,245.98 3764.87,240.48 3775.5,235.5C 3779.66,234.258 3783.32,232.258 3786.5,229.5C 3801.52,221.325 3816.85,213.659 3832.5,206.5C 3837.25,205.29 3841.58,203.29 3845.5,200.5C 3847.18,198.992 3849.18,197.992 3851.5,197.5C 3856.25,196.29 3860.58,194.29 3864.5,191.5C 3921.65,164.332 3980.32,140.666 4040.5,120.5C 4049.17,118.609 4057.5,115.943 4065.5,112.5C 4071.66,109.999 4077.99,107.666 4084.5,105.5C 4090.01,107.332 4095.34,109.332 4100.5,111.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d4001a",
    d: "M 4696.5,107.5 C 4739.87,125.518 4782.54,145.184 4824.5,166.5C 4581.38,240.737 4355.71,349.57 4147.5,493C 4143.62,492.573 4139.95,491.24 4136.5,489C 4119,478.747 4101.33,468.747 4083.5,459C 4057.8,445.484 4032.13,431.984 4006.5,418.5C 4219.12,277.544 4449.12,173.878 4696.5,107.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.525
    },
    fill: "#0267af",
    d: "M 4065.5,112.5 C 4057.5,115.943 4049.17,118.609 4040.5,120.5C 4048.5,117.057 4056.83,114.391 4065.5,112.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.553
    },
    fill: "#0369b1",
    d: "M 4100.5,111.5 C 4110.17,113.724 4119.5,116.724 4128.5,120.5C 4118.83,118.276 4109.5,115.276 4100.5,111.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0052c1",
    d: "M 4238.5,239.5 C 4234.42,240.376 4230.75,242.043 4227.5,244.5C 4211.54,252.158 4195.54,259.825 4179.5,267.5C 4174.75,268.71 4170.42,270.71 4166.5,273.5C 4162.15,276.341 4157.48,278.674 4152.5,280.5C 4146.35,282.74 4140.68,285.74 4135.5,289.5C 4130.91,290.46 4126.91,292.46 4123.5,295.5C 4116.98,299.928 4109.98,303.594 4102.5,306.5C 4098.34,307.742 4094.68,309.742 4091.5,312.5C 4061.4,329.387 4031.4,346.553 4001.5,364C 3994.05,361.942 3987.05,358.776 3980.5,354.5C 3972.42,349.126 3963.75,344.793 3954.5,341.5C 3947.52,338.675 3940.85,335.341 3934.5,331.5C 3929.92,328.378 3924.92,326.044 3919.5,324.5C 3910.4,320.787 3901.4,316.787 3892.5,312.5C 3891.17,311.833 3891.17,311.167 3892.5,310.5C 3923.25,292.458 3954.58,275.458 3986.5,259.5C 3992.65,257.26 3998.32,254.26 4003.5,250.5C 4012.52,245.325 4021.85,240.659 4031.5,236.5C 4040.26,233.287 4048.59,229.287 4056.5,224.5C 4063.11,220.404 4070.11,217.071 4077.5,214.5C 4081.58,213.624 4085.25,211.957 4088.5,209.5C 4131.54,189.202 4175.37,170.535 4220,153.5C 4256.72,167.946 4292.89,183.612 4328.5,200.5C 4298.51,213.498 4268.51,226.498 4238.5,239.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d4001a",
    d: "M 4859.5,185.5 C 4864.03,186.763 4868.37,188.597 4872.5,191C 4906.83,209.827 4940.83,229.161 4974.5,249C 4975.83,249.667 4975.83,250.333 4974.5,251C 4747.17,346.703 4537.83,470.703 4346.5,623C 4297.71,589.242 4248.04,556.408 4197.5,524.5C 4373.56,398.609 4563.56,296.776 4767.5,219C 4798.16,207.505 4828.83,196.338 4859.5,185.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.604
    },
    fill: "#0067b0",
    d: "M 3864.5,191.5 C 3860.58,194.29 3856.25,196.29 3851.5,197.5C 3855.42,194.71 3859.75,192.71 3864.5,191.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.627
    },
    fill: "#0369b1",
    d: "M 3845.5,200.5 C 3841.58,203.29 3837.25,205.29 3832.5,206.5C 3836.42,203.71 3840.75,201.71 3845.5,200.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0052c1",
    d: "M 1686.5,213.5 C 1687.49,236.758 1687.82,260.092 1687.5,283.5C 1686.17,283.5 1684.83,283.5 1683.5,283.5C 1672.63,281.684 1661.96,282.517 1651.5,286C 1643.56,290.046 1639.22,296.546 1638.5,305.5C 1637.51,316.321 1637.17,327.321 1637.5,338.5C 1654.5,338.5 1671.5,338.5 1688.5,338.5C 1688.5,359.833 1688.5,381.167 1688.5,402.5C 1671.5,402.5 1654.5,402.5 1637.5,402.5C 1637.5,476.167 1637.5,549.833 1637.5,623.5C 1607.17,623.5 1576.83,623.5 1546.5,623.5C 1546.83,549.998 1546.5,476.665 1545.5,403.5C 1533.34,402.505 1521.01,402.171 1508.5,402.5C 1508.5,381.167 1508.5,359.833 1508.5,338.5C 1521.01,338.829 1533.34,338.495 1545.5,337.5C 1545.33,321.497 1545.5,305.497 1546,289.5C 1546.99,266.842 1555.15,247.342 1570.5,231C 1583.21,220.315 1597.88,213.981 1614.5,212C 1638.6,208.988 1662.6,209.488 1686.5,213.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.516
    },
    fill: "#0066b0",
    d: "M 4088.5,209.5 C 4085.25,211.957 4081.58,213.624 4077.5,214.5C 4080.75,212.043 4084.42,210.376 4088.5,209.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.777
    },
    fill: "#0067b1",
    d: "M 1686.5,213.5 C 1688.49,236.81 1689.16,260.476 1688.5,284.5C 1686.59,284.784 1684.92,284.451 1683.5,283.5C 1684.83,283.5 1686.17,283.5 1687.5,283.5C 1687.82,260.092 1687.49,236.758 1686.5,213.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.13
    },
    fill: "#0067af",
    d: "M 1983.5,218.5 C 1938.43,218.172 1893.43,218.506 1848.5,219.5C 1870.66,218.167 1893.16,217.5 1916,217.5C 1938.67,217.5 1961.17,217.833 1983.5,218.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5
    },
    fill: "#0066af",
    d: "M 172.5,218.5 C 118.5,218.5 64.5,218.5 10.5,218.5C 10.5,353.5 10.5,488.5 10.5,623.5C 67.8333,623.5 125.167,623.5 182.5,623.5C 125.002,624.499 67.3357,624.832 9.5,624.5C 9.5,488.833 9.5,353.167 9.5,217.5C 64.0026,217.168 118.336,217.501 172.5,218.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0052c1",
    d: "M 172.5,218.5 C 192.157,217.832 210.823,221.498 228.5,229.5C 232.182,232.008 236.182,234.008 240.5,235.5C 247.281,237.952 252.948,241.952 257.5,247.5C 260.5,251.167 263.833,254.5 267.5,257.5C 278.25,268.663 285.083,281.996 288,297.5C 292.778,322.164 289.111,345.498 277,367.5C 274.015,372.311 270.515,376.644 266.5,380.5C 263.5,382.833 260.833,385.5 258.5,388.5C 254.759,392.218 250.759,395.718 246.5,399C 238.767,403.197 231.1,407.364 223.5,411.5C 231.521,415.022 239.521,418.855 247.5,423C 252.929,426.369 257.929,430.202 262.5,434.5C 266.5,439.167 270.833,443.5 275.5,447.5C 289.301,463.121 297.135,481.455 299,502.5C 302.265,564.139 274.098,602.972 214.5,619C 203.992,621.696 193.325,623.196 182.5,623.5C 125.167,623.5 67.8333,623.5 10.5,623.5C 10.5,488.5 10.5,353.5 10.5,218.5C 64.5,218.5 118.5,218.5 172.5,218.5 Z M 148.5,290.5 C 184.748,292.597 199.581,311.597 193,347.5C 189.76,360.406 181.927,369.24 169.5,374C 163.916,375.979 158.25,377.479 152.5,378.5C 138.5,378.5 124.5,378.5 110.5,378.5C 110.5,349.167 110.5,319.833 110.5,290.5C 123.167,290.5 135.833,290.5 148.5,290.5 Z M 110.5,447.5 C 126.531,447.176 142.531,447.676 158.5,449C 181.444,452.944 194.611,466.444 198,489.5C 199.608,502.856 197.441,515.523 191.5,527.5C 188.791,530.208 186.458,533.208 184.5,536.5C 175.312,543.233 164.979,547.233 153.5,548.5C 139.167,548.5 124.833,548.5 110.5,548.5C 110.5,514.833 110.5,481.167 110.5,447.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0052c1",
    d: "M 908.5,218.5 C 939.167,218.5 969.833,218.5 1000.5,218.5C 1000.17,287.17 1000.5,355.837 1001.5,424.5C 1002.11,424.376 1002.44,424.043 1002.5,423.5C 1009.82,413.521 1017.48,403.854 1025.5,394.5C 1027.59,393.415 1028.92,391.749 1029.5,389.5C 1042.11,371.947 1055.45,354.947 1069.5,338.5C 1099.84,338.333 1130.17,338.5 1160.5,339C 1158.21,340.777 1156.54,342.944 1155.5,345.5C 1132.19,372.48 1108.86,399.48 1085.5,426.5C 1110.8,490.754 1135.8,555.087 1160.5,619.5C 1160.33,620.822 1160.66,621.989 1161.5,623C 1145.67,623.167 1129.83,623.333 1114,623.5C 1097.61,623.485 1081.45,622.819 1065.5,621.5C 1050.4,581.047 1035.57,540.38 1021,499.5C 1015.59,505.397 1010.43,511.397 1005.5,517.5C 1005.57,517.062 1005.4,516.728 1005,516.5C 1003.67,517.833 1002.33,519.167 1001,520.5C 1000.5,554.832 1000.33,589.165 1000.5,623.5C 969.833,623.5 939.167,623.5 908.5,623.5C 908.5,488.5 908.5,353.5 908.5,218.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5
    },
    fill: "#0066af",
    d: "M 908.5,218.5 C 939.329,217.502 970.329,217.169 1001.5,217.5C 1001.17,286.335 1001.5,355.002 1002.5,423.5C 1002.44,424.043 1002.11,424.376 1001.5,424.5C 1000.5,355.837 1000.17,287.17 1000.5,218.5C 969.833,218.5 939.167,218.5 908.5,218.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0052c1",
    d: "M 1983.5,218.5 C 2012.91,352.557 2041.58,486.891 2069.5,621.5C 2036.85,623.493 2003.85,624.16 1970.5,623.5C 1970.74,622.209 1970.4,621.209 1969.5,620.5C 1963.88,595.075 1958.88,569.409 1954.5,543.5C 1939.18,542.167 1923.51,541.501 1907.5,541.5C 1891.66,541.5 1876,541.833 1860.5,542.5C 1855.32,568.725 1849.66,594.725 1843.5,620.5C 1842.6,621.209 1842.26,622.209 1842.5,623.5C 1813.17,623.5 1783.83,623.5 1754.5,623.5C 1754.5,622.5 1754.5,621.5 1754.5,620.5C 1785.09,486.549 1816.42,352.882 1848.5,219.5C 1893.43,218.506 1938.43,218.172 1983.5,218.5 Z M 1912.5,314.5 C 1920.88,365.733 1929.88,416.733 1939.5,467.5C 1918.53,469.489 1897.19,470.156 1875.5,469.5C 1875.5,468.5 1875.5,467.5 1875.5,466.5C 1886.91,415.107 1897.58,363.44 1907.5,311.5C 1908.32,309.611 1909.16,307.611 1910,305.5C 1910.66,308.678 1911.49,311.678 1912.5,314.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.313
    },
    fill: "#0066ae",
    d: "M 3106.5,218.5 C 3075.83,218.5 3045.17,218.5 3014.5,218.5C 3014.5,245.833 3014.5,273.167 3014.5,300.5C 3013.5,273.005 3013.17,245.338 3013.5,217.5C 3044.67,217.169 3075.67,217.502 3106.5,218.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0051c2",
    d: "M 3106.5,218.5 C 3106.5,245.833 3106.5,273.167 3106.5,300.5C 3075.83,300.5 3045.17,300.5 3014.5,300.5C 3014.5,273.167 3014.5,245.833 3014.5,218.5C 3045.17,218.5 3075.83,218.5 3106.5,218.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.525
    },
    fill: "#0067b0",
    d: "M 3988.5,216.5 C 3982.59,220.288 3976.26,223.288 3969.5,225.5C 3975.41,221.712 3981.74,218.712 3988.5,216.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.467
    },
    fill: "#0067b1",
    d: "M 228.5,229.5 C 233.086,230.46 237.086,232.46 240.5,235.5C 236.182,234.008 232.182,232.008 228.5,229.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.465
    },
    fill: "#0067af",
    d: "M 3786.5,229.5 C 3783.32,232.258 3779.66,234.258 3775.5,235.5C 3778.68,232.742 3782.34,230.742 3786.5,229.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.504
    },
    fill: "#0067b1",
    d: "M 4056.5,224.5 C 4048.59,229.287 4040.26,233.287 4031.5,236.5C 4039.41,231.713 4047.74,227.713 4056.5,224.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.498
    },
    fill: "#0066b1",
    d: "M 3961.5,229.5 C 3953.65,234.595 3945.31,238.928 3936.5,242.5C 3944.35,237.405 3952.69,233.072 3961.5,229.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.491
    },
    fill: "#0066b0",
    d: "M 4238.5,239.5 C 4235.25,241.957 4231.58,243.624 4227.5,244.5C 4230.75,242.043 4234.42,240.376 4238.5,239.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.413
    },
    fill: "#0066b0",
    d: "M 257.5,247.5 C 261.833,249.833 265.167,253.167 267.5,257.5C 263.833,254.5 260.5,251.167 257.5,247.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.61
    },
    fill: "#0068b1",
    d: "M 4003.5,250.5 C 3998.32,254.26 3992.65,257.26 3986.5,259.5C 3991.68,255.74 3997.35,252.74 4003.5,250.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.545
    },
    fill: "#0069b1",
    d: "M 4179.5,267.5 C 4175.58,270.29 4171.25,272.29 4166.5,273.5C 4170.42,270.71 4174.75,268.71 4179.5,267.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.467
    },
    fill: "#0167b1",
    d: "M 4152.5,280.5 C 4147.32,284.26 4141.65,287.26 4135.5,289.5C 4140.68,285.74 4146.35,282.74 4152.5,280.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.337
    },
    fill: "#0066af",
    d: "M 148.5,290.5 C 135.833,290.5 123.167,290.5 110.5,290.5C 110.5,319.833 110.5,349.167 110.5,378.5C 124.5,378.5 138.5,378.5 152.5,378.5C 138.343,379.496 124.01,379.829 109.5,379.5C 109.5,349.5 109.5,319.5 109.5,289.5C 122.677,289.171 135.677,289.505 148.5,290.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.49
    },
    fill: "#0067b0",
    d: "M 4135.5,289.5 C 4131.82,292.008 4127.82,294.008 4123.5,295.5C 4126.91,292.46 4130.91,290.46 4135.5,289.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.557
    },
    fill: "#0066b0",
    d: "M 1638.5,305.5 C 1638.5,316.167 1638.5,326.833 1638.5,337.5C 1655.34,337.17 1672.01,337.503 1688.5,338.5C 1671.5,338.5 1654.5,338.5 1637.5,338.5C 1637.17,327.321 1637.51,316.321 1638.5,305.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.488
    },
    fill: "#0e64a6",
    d: "M 1912.5,314.5 C 1911.49,311.678 1910.66,308.678 1910,305.5C 1909.16,307.611 1908.32,309.611 1907.5,311.5C 1907.32,309.409 1907.65,307.409 1908.5,305.5C 1909.32,304.614 1910.32,304.281 1911.5,304.5C 1912.05,307.807 1912.38,311.14 1912.5,314.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.462
    },
    fill: "#0364ac",
    d: "M 4102.5,306.5 C 4099.32,309.258 4095.66,311.258 4091.5,312.5C 4094.68,309.742 4098.34,307.742 4102.5,306.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.46
    },
    fill: "#0066b0",
    d: "M 3919.5,324.5 C 3924.92,326.044 3929.92,328.378 3934.5,331.5C 3929.08,329.956 3924.08,327.622 3919.5,324.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0052c1",
    d: "M 1427.5,612.5 C 1422.68,614.074 1418.35,616.407 1414.5,619.5C 1401.85,625.165 1388.51,628.665 1374.5,630C 1295.49,636.28 1247.99,600.78 1232,523.5C 1227.17,494.411 1227.34,465.411 1232.5,436.5C 1234.43,431.427 1235.77,426.094 1236.5,420.5C 1251.51,368.004 1286.17,338.171 1340.5,331C 1418.93,325.464 1466.43,360.964 1483,437.5C 1490.51,479.545 1486.84,520.545 1472,560.5C 1462.98,582.913 1448.15,600.247 1427.5,612.5 Z M 1350.5,389.5 C 1364.07,387.172 1374.23,391.839 1381,403.5C 1384.75,412.815 1387.08,422.481 1388,432.5C 1390.86,463.265 1390.86,493.931 1388,524.5C 1387.12,538.031 1383.45,550.698 1377,562.5C 1367.25,572.311 1356.09,574.145 1343.5,568C 1335.99,561.154 1331.49,552.654 1330,542.5C 1322.84,499.831 1322.84,457.164 1330,414.5C 1332.17,402.075 1339,393.742 1350.5,389.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0052c1",
    d: "M 2723.5,359.5 C 2725.43,363.1 2728.1,366.1 2731.5,368.5C 2742.14,380.755 2749.97,394.755 2755,410.5C 2760.63,428.474 2764.13,446.807 2765.5,465.5C 2764.51,476.988 2764.17,488.655 2764.5,500.5C 2713.17,500.5 2661.83,500.5 2610.5,500.5C 2610.5,502.167 2610.5,503.833 2610.5,505.5C 2610.24,522.961 2614.74,539.295 2624,554.5C 2640.06,570.311 2657.89,572.477 2677.5,561C 2682.36,557.303 2686.7,553.136 2690.5,548.5C 2693.79,545.6 2695.79,541.933 2696.5,537.5C 2696.84,535.146 2697.34,532.813 2698,530.5C 2698.72,529.941 2699.56,529.608 2700.5,529.5C 2720.57,536.635 2740.57,543.968 2760.5,551.5C 2761.37,553.466 2761.21,555.466 2760,557.5C 2754.66,569.535 2747.83,580.535 2739.5,590.5C 2734.89,593.436 2730.89,597.102 2727.5,601.5C 2722.57,607.3 2716.57,611.634 2709.5,614.5C 2707.18,614.992 2705.18,615.992 2703.5,617.5C 2690.89,624.578 2677.22,628.745 2662.5,630C 2591.4,635.047 2545.57,603.547 2525,535.5C 2514.12,492.995 2515.78,450.995 2530,409.5C 2535.49,393.819 2543.99,380.152 2555.5,368.5C 2558.83,365.833 2561.83,362.833 2564.5,359.5C 2580.51,344.5 2599.51,335.333 2621.5,332C 2654.64,325.967 2685.31,331.967 2713.5,350C 2717.1,352.952 2720.43,356.118 2723.5,359.5 Z M 2679.5,445.5 C 2656.83,445.5 2634.17,445.5 2611.5,445.5C 2611.5,439.833 2611.5,434.167 2611.5,428.5C 2612.92,421.402 2615.09,414.402 2618,407.5C 2629.36,388.498 2644.86,384.331 2664.5,395C 2672.82,402.618 2677.32,412.118 2678,423.5C 2678.94,430.806 2679.44,438.14 2679.5,445.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.373
    },
    fill: "#0067af",
    d: "M 2980.5,331.5 C 2981.57,330.566 2982.9,330.232 2984.5,330.5C 2984.67,362.168 2984.5,393.835 2984,425.5C 2982.7,424.915 2981.53,424.249 2980.5,423.5C 2981.5,423.5 2982.5,423.5 2983.5,423.5C 2983.5,392.833 2983.5,362.167 2983.5,331.5C 2982.5,331.5 2981.5,331.5 2980.5,331.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0052c1",
    d: "M 3389.5,432.5 C 3389.5,436.167 3389.5,439.833 3389.5,443.5C 3363.5,443.5 3337.5,443.5 3311.5,443.5C 3311.82,437.642 3311.49,431.975 3310.5,426.5C 3309.81,413.91 3305.14,403.077 3296.5,394C 3277.33,384.495 3263.16,389.329 3254,408.5C 3250.89,417.932 3248.89,427.599 3248,437.5C 3246.52,460.148 3246.19,482.815 3247,505.5C 3247.3,520.179 3249.63,534.512 3254,548.5C 3262.35,567.293 3276.19,572.793 3295.5,565C 3306.92,557.345 3313.09,546.512 3314,532.5C 3314.33,526.833 3314.67,521.167 3315,515.5C 3315.39,514.572 3316.05,513.905 3317,513.5C 3340.44,517.254 3363.94,520.587 3387.5,523.5C 3386.06,546.924 3379.23,568.59 3367,588.5C 3365.28,591.288 3363.11,593.621 3360.5,595.5C 3356.83,598.5 3353.5,601.833 3350.5,605.5C 3341.79,614.197 3331.45,620.364 3319.5,624C 3289.03,632.985 3258.7,632.651 3228.5,623C 3216.13,618.158 3205.13,611.325 3195.5,602.5C 3191.83,598.167 3187.83,594.167 3183.5,590.5C 3174.85,581.885 3168.19,571.885 3163.5,560.5C 3162.62,556.418 3160.96,552.751 3158.5,549.5C 3148.3,523.903 3144.46,497.236 3147,469.5C 3149.67,430.868 3163.33,396.868 3188,367.5C 3222.8,333.857 3263.97,322.691 3311.5,334C 3349.27,345.103 3373.77,369.603 3385,407.5C 3387.6,415.65 3389.1,423.984 3389.5,432.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0052c1",
    d: "M 568.5,622.5 C 537.338,623.498 506.004,623.832 474.5,623.5C 472.943,615.701 471.777,607.701 471,599.5C 440.618,628.887 405.452,636.721 365.5,623C 339.536,610.265 325.036,589.432 322,560.5C 319.71,541.907 322.71,524.24 331,507.5C 333.277,503.92 335.777,500.586 338.5,497.5C 340.914,496.089 342.581,494.089 343.5,491.5C 351.786,481.541 361.786,473.875 373.5,468.5C 378.251,467.29 382.584,465.29 386.5,462.5C 390.444,460.036 394.777,458.37 399.5,457.5C 403.784,456.739 407.784,455.405 411.5,453.5C 429.963,447.675 448.963,444.008 468.5,442.5C 468.891,430.447 468.391,418.447 467,406.5C 461.523,393.012 451.69,387.845 437.5,391C 428.124,393.889 421.957,400.056 419,409.5C 416.741,415.293 415.575,421.293 415.5,427.5C 388.064,422.346 360.731,416.679 333.5,410.5C 336.279,397.661 341.112,385.661 348,374.5C 349.719,371.712 351.885,369.379 354.5,367.5C 357.5,365.167 360.167,362.5 362.5,359.5C 370.779,351.349 380.446,345.182 391.5,341C 430.143,327.217 468.81,327.217 507.5,341C 537.868,352.692 555.702,374.526 561,406.5C 561.333,467.5 561.667,528.5 562,589.5C 562.235,600.92 564.402,611.92 568.5,622.5 Z M 465.5,487.5 C 466.5,487.5 467.5,487.5 468.5,487.5C 468.5,508.833 468.5,530.167 468.5,551.5C 465.167,554.167 462.167,557.167 459.5,560.5C 448.292,569.625 436.292,570.792 423.5,564C 416.353,557.233 412.686,548.9 412.5,539C 412.181,516.344 422.515,501.011 443.5,493C 450.72,490.528 458.053,488.695 465.5,487.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0052c1",
    d: "M 850.5,385.5 C 850.5,464.833 850.5,544.167 850.5,623.5C 820.167,623.5 789.833,623.5 759.5,623.5C 759.832,555.998 759.499,488.665 758.5,421.5C 756.031,406.757 747.364,400.59 732.5,403C 722.208,406.293 713.875,412.293 707.5,421C 708.81,488.427 708.81,555.927 707.5,623.5C 676.833,623.5 646.167,623.5 615.5,623.5C 615.5,528.5 615.5,433.5 615.5,338.5C 645.5,338.5 675.5,338.5 705.5,338.5C 705.5,348.167 705.5,357.833 705.5,367.5C 709.673,366.005 713.006,363.338 715.5,359.5C 740.026,336.827 769.026,327.661 802.5,332C 830.96,338.628 846.96,356.461 850.5,385.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0052c1",
    d: "M 2456.5,345.5 C 2458.83,348.5 2461.5,351.167 2464.5,353.5C 2468.3,357.084 2471.14,361.417 2473,366.5C 2475.47,373.037 2477.3,379.704 2478.5,386.5C 2477.5,465.332 2477.17,544.332 2477.5,623.5C 2447.5,623.5 2417.5,623.5 2387.5,623.5C 2387.67,558.166 2387.5,492.832 2387,427.5C 2387.02,408.856 2377.86,401.022 2359.5,404C 2349.74,407.089 2341.57,412.589 2335,420.5C 2334.5,488.166 2334.33,555.833 2334.5,623.5C 2304.5,623.5 2274.5,623.5 2244.5,623.5C 2244.83,556.665 2244.5,489.998 2243.5,423.5C 2241.24,407.099 2231.91,400.599 2215.5,404C 2206.04,406.964 2198.04,412.131 2191.5,419.5C 2190.5,487.331 2190.17,555.331 2190.5,623.5C 2160.5,623.5 2130.5,623.5 2100.5,623.5C 2100.5,528.5 2100.5,433.5 2100.5,338.5C 2130.5,338.5 2160.5,338.5 2190.5,338.5C 2190.5,342.5 2190.5,346.5 2190.5,350.5C 2190.17,356.206 2190.5,361.872 2191.5,367.5C 2192.11,367.376 2192.44,367.043 2192.5,366.5C 2218.76,340.381 2250.43,328.881 2287.5,332C 2308.31,337.159 2322.81,349.659 2331,369.5C 2358.18,339.105 2392.01,326.939 2432.5,333C 2441.84,334.836 2449.84,339.003 2456.5,345.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0052c1",
    d: "M 2980.5,331.5 C 2981.5,331.5 2982.5,331.5 2983.5,331.5C 2983.5,362.167 2983.5,392.833 2983.5,423.5C 2982.5,423.5 2981.5,423.5 2980.5,423.5C 2965.94,418.186 2950.94,416.352 2935.5,418C 2924.13,419.732 2913.79,423.899 2904.5,430.5C 2901.27,432.22 2898.44,434.553 2896,437.5C 2895.5,499.499 2895.33,561.499 2895.5,623.5C 2864.83,623.5 2834.17,623.5 2803.5,623.5C 2803.5,528.5 2803.5,433.5 2803.5,338.5C 2833.17,338.5 2862.83,338.5 2892.5,338.5C 2893.33,350.993 2893.83,363.66 2894,376.5C 2896.7,372.975 2899.53,369.642 2902.5,366.5C 2906.5,363.167 2910.17,359.5 2913.5,355.5C 2932.69,339.212 2955.02,331.212 2980.5,331.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0052c1",
    d: "M 3659.5,622.5 C 3628.34,623.498 3597,623.832 3565.5,623.5C 3564.07,615.682 3562.9,607.682 3562,599.5C 3531.62,628.887 3496.45,636.721 3456.5,623C 3430.54,610.265 3416.04,589.432 3413,560.5C 3409.63,518.223 3426.8,487.556 3464.5,468.5C 3469.25,467.29 3473.58,465.29 3477.5,462.5C 3503.61,451.405 3530.95,444.738 3559.5,442.5C 3559.89,430.447 3559.39,418.447 3558,406.5C 3552.52,393.012 3542.69,387.845 3528.5,391C 3519.12,393.889 3512.96,400.056 3510,409.5C 3507.88,415.326 3506.71,421.326 3506.5,427.5C 3479.06,422.346 3451.73,416.679 3424.5,410.5C 3427.55,394.078 3434.55,379.745 3445.5,367.5C 3448.83,364.833 3451.83,361.833 3454.5,358.5C 3466,348.216 3479.34,341.049 3494.5,337C 3529.55,327.857 3564.21,329.19 3598.5,341C 3628.87,352.692 3646.7,374.526 3652,406.5C 3652.33,467.5 3652.67,528.5 3653,589.5C 3653.24,600.92 3655.4,611.92 3659.5,622.5 Z M 3556.5,487.5 C 3557.5,487.5 3558.5,487.5 3559.5,487.5C 3559.5,508.833 3559.5,530.167 3559.5,551.5C 3553.1,559.209 3545.1,564.709 3535.5,568C 3515.08,569.255 3504.42,559.588 3503.5,539C 3503.18,516.344 3513.51,501.011 3534.5,493C 3541.72,490.528 3549.05,488.695 3556.5,487.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.372
    },
    fill: "#0067af",
    d: "M 715.5,359.5 C 713.006,363.338 709.673,366.005 705.5,367.5C 705.5,357.833 705.5,348.167 705.5,338.5C 675.5,338.5 645.5,338.5 615.5,338.5C 615.5,433.5 615.5,528.5 615.5,623.5C 646.167,623.5 676.833,623.5 707.5,623.5C 676.671,624.498 645.671,624.831 614.5,624.5C 614.5,528.833 614.5,433.167 614.5,337.5C 645.167,337.5 675.833,337.5 706.5,337.5C 706.334,347.172 706.5,356.839 707,366.5C 709.436,363.553 712.269,361.22 715.5,359.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.496
    },
    fill: "#0066af",
    d: "M 1069.5,338.5 C 1100.33,337.336 1131.33,337.169 1162.5,338C 1160.67,340.998 1158.33,343.498 1155.5,345.5C 1156.54,342.944 1158.21,340.777 1160.5,339C 1130.17,338.5 1099.84,338.333 1069.5,338.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.42
    },
    fill: "#0067af",
    d: "M 1545.5,337.5 C 1533.34,338.495 1521.01,338.829 1508.5,338.5C 1508.5,359.833 1508.5,381.167 1508.5,402.5C 1521.01,402.171 1533.34,402.505 1545.5,403.5C 1532.83,403.5 1520.17,403.5 1507.5,403.5C 1507.5,381.5 1507.5,359.5 1507.5,337.5C 1520.17,337.5 1532.83,337.5 1545.5,337.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.406
    },
    fill: "#0067af",
    d: "M 2892.5,338.5 C 2862.83,338.5 2833.17,338.5 2803.5,338.5C 2803.5,433.5 2803.5,528.5 2803.5,623.5C 2834.17,623.5 2864.83,623.5 2895.5,623.5C 2864.67,624.498 2833.67,624.831 2802.5,624.5C 2802.5,528.833 2802.5,433.167 2802.5,337.5C 2832.67,337.169 2862.67,337.502 2892.5,338.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.406
    },
    fill: "#0066af",
    d: "M 3106.5,338.5 C 3075.83,338.5 3045.17,338.5 3014.5,338.5C 3014.5,433.5 3014.5,528.5 3014.5,623.5C 3045.17,623.5 3075.83,623.5 3106.5,623.5C 3075.67,624.498 3044.67,624.831 3013.5,624.5C 3013.5,528.833 3013.5,433.167 3013.5,337.5C 3044.67,337.169 3075.67,337.502 3106.5,338.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0051c2",
    d: "M 3106.5,338.5 C 3106.5,433.5 3106.5,528.5 3106.5,623.5C 3075.83,623.5 3045.17,623.5 3014.5,623.5C 3014.5,528.5 3014.5,433.5 3014.5,338.5C 3045.17,338.5 3075.83,338.5 3106.5,338.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.488
    },
    fill: "#0066b1",
    d: "M 3954.5,341.5 C 3963.75,344.793 3972.42,349.126 3980.5,354.5C 3971.52,350.675 3962.85,346.341 3954.5,341.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.47
    },
    fill: "#0067b1",
    d: "M 2456.5,345.5 C 2460.17,347.167 2462.83,349.833 2464.5,353.5C 2461.5,351.167 2458.83,348.5 2456.5,345.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.241
    },
    fill: "#0066ae",
    d: "M 2190.5,350.5 C 2191.17,355.833 2191.83,361.167 2192.5,366.5C 2192.44,367.043 2192.11,367.376 2191.5,367.5C 2190.5,361.872 2190.17,356.206 2190.5,350.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.385
    },
    fill: "#0066b2",
    d: "M 2913.5,355.5 C 2910.17,359.5 2906.5,363.167 2902.5,366.5C 2905.17,361.833 2908.83,358.167 2913.5,355.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.553
    },
    fill: "#0369b0",
    d: "M 3454.5,358.5 C 3451.83,361.833 3448.83,364.833 3445.5,367.5C 3447.5,363.5 3450.5,360.5 3454.5,358.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.608
    },
    fill: "#006ab3",
    d: "M 362.5,359.5 C 360.167,362.5 357.5,365.167 354.5,367.5C 356.167,363.833 358.833,361.167 362.5,359.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.456
    },
    fill: "#0369b2",
    d: "M 2564.5,359.5 C 2561.83,362.833 2558.83,365.833 2555.5,368.5C 2557.5,364.5 2560.5,361.5 2564.5,359.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.599
    },
    fill: "#0066b0",
    d: "M 2723.5,359.5 C 2726.9,361.9 2729.57,364.9 2731.5,368.5C 2728.1,366.1 2725.43,363.1 2723.5,359.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.493
    },
    fill: "#0066b1",
    d: "M 266.5,380.5 C 264.833,384.167 262.167,386.833 258.5,388.5C 260.833,385.5 263.5,382.833 266.5,380.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.651
    },
    fill: "#0067b1",
    d: "M 850.5,385.5 C 851.499,464.998 851.833,544.665 851.5,624.5C 820.5,624.5 789.5,624.5 758.5,624.5C 758.5,556.833 758.5,489.167 758.5,421.5C 759.499,488.665 759.832,555.998 759.5,623.5C 789.833,623.5 820.167,623.5 850.5,623.5C 850.5,544.167 850.5,464.833 850.5,385.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.619
    },
    fill: "#0067b1",
    d: "M 2478.5,386.5 C 2478.5,465.833 2478.5,545.167 2478.5,624.5C 2448,624.831 2417.66,624.498 2387.5,623.5C 2417.5,623.5 2447.5,623.5 2477.5,623.5C 2477.17,544.332 2477.5,465.332 2478.5,386.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.459
    },
    fill: "#0e77b9",
    d: "M 1029.5,389.5 C 1028.92,391.749 1027.59,393.415 1025.5,394.5C 1026.08,392.251 1027.41,390.585 1029.5,389.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.67
    },
    fill: "#0066b1",
    d: "M 1688.5,402.5 C 1672.01,403.497 1655.34,403.83 1638.5,403.5C 1638.5,477.167 1638.5,550.833 1638.5,624.5C 1607.5,624.5 1576.5,624.5 1545.5,624.5C 1545.5,550.833 1545.5,477.167 1545.5,403.5C 1546.5,476.665 1546.83,549.998 1546.5,623.5C 1576.83,623.5 1607.17,623.5 1637.5,623.5C 1637.5,549.833 1637.5,476.167 1637.5,402.5C 1654.5,402.5 1671.5,402.5 1688.5,402.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.408
    },
    fill: "#0066af",
    d: "M 2190.5,338.5 C 2160.5,338.5 2130.5,338.5 2100.5,338.5C 2100.5,433.5 2100.5,528.5 2100.5,623.5C 2130.5,623.5 2160.5,623.5 2190.5,623.5C 2190.17,555.331 2190.5,487.331 2191.5,419.5C 2191.5,487.833 2191.5,556.167 2191.5,624.5C 2160.83,624.5 2130.17,624.5 2099.5,624.5C 2099.5,528.833 2099.5,433.167 2099.5,337.5C 2130,337.169 2160.34,337.502 2190.5,338.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.668
    },
    fill: "#0066b1",
    d: "M 2243.5,423.5 C 2244.5,489.998 2244.83,556.665 2244.5,623.5C 2274.5,623.5 2304.5,623.5 2334.5,623.5C 2304.34,624.498 2274,624.831 2243.5,624.5C 2243.5,557.5 2243.5,490.5 2243.5,423.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.625
    },
    fill: "#0067b1",
    d: "M 1236.5,420.5 C 1235.77,426.094 1234.43,431.427 1232.5,436.5C 1232.92,430.83 1234.25,425.497 1236.5,420.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.361
    },
    fill: "#0067af",
    d: "M 2611.5,428.5 C 2611.5,434.167 2611.5,439.833 2611.5,445.5C 2634.17,445.5 2656.83,445.5 2679.5,445.5C 2656.67,446.498 2633.67,446.831 2610.5,446.5C 2610.18,440.31 2610.51,434.31 2611.5,428.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.063
    },
    fill: "#0060af",
    d: "M 2904.5,430.5 C 2902.2,433.297 2899.7,435.964 2897,438.5C 2896.83,500.335 2896.33,562.001 2895.5,623.5C 2895.33,561.499 2895.5,499.499 2896,437.5C 2898.44,434.553 2901.27,432.22 2904.5,430.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.562
    },
    fill: "#0066b0",
    d: "M 262.5,434.5 C 267.833,437.833 272.167,442.167 275.5,447.5C 270.833,443.5 266.5,439.167 262.5,434.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.376
    },
    fill: "#0067af",
    d: "M 3310.5,426.5 C 3311.49,431.975 3311.82,437.642 3311.5,443.5C 3337.5,443.5 3363.5,443.5 3389.5,443.5C 3389.5,439.833 3389.5,436.167 3389.5,432.5C 3390.48,436.298 3390.82,440.298 3390.5,444.5C 3363.83,444.5 3337.17,444.5 3310.5,444.5C 3310.5,438.5 3310.5,432.5 3310.5,426.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.277
    },
    fill: "#0066af",
    d: "M 110.5,447.5 C 110.5,481.167 110.5,514.833 110.5,548.5C 124.833,548.5 139.167,548.5 153.5,548.5C 139.01,549.496 124.343,549.829 109.5,549.5C 109.168,515.329 109.502,481.329 110.5,447.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.522
    },
    fill: "#0064ae",
    d: "M 411.5,453.5 C 407.784,455.405 403.784,456.739 399.5,457.5C 403.085,455.194 407.085,453.861 411.5,453.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.469
    },
    fill: "#0067b2",
    d: "M 3477.5,462.5 C 3473.58,465.29 3469.25,467.29 3464.5,468.5C 3468.42,465.71 3472.75,463.71 3477.5,462.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.485
    },
    fill: "#0067b0",
    d: "M 386.5,462.5 C 382.584,465.29 378.251,467.29 373.5,468.5C 377.416,465.71 381.749,463.71 386.5,462.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.506
    },
    fill: "#0066af",
    d: "M 2765.5,465.5 C 2765.5,477.5 2765.5,489.5 2765.5,501.5C 2714.17,501.5 2662.83,501.5 2611.5,501.5C 2611.77,503.099 2611.43,504.432 2610.5,505.5C 2610.5,503.833 2610.5,502.167 2610.5,500.5C 2661.83,500.5 2713.17,500.5 2764.5,500.5C 2764.17,488.655 2764.51,476.988 2765.5,465.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.283
    },
    fill: "#0067af",
    d: "M 1875.5,466.5 C 1875.5,467.5 1875.5,468.5 1875.5,469.5C 1897.19,470.156 1918.53,469.489 1939.5,467.5C 1940.4,468.209 1940.74,469.209 1940.5,470.5C 1918.5,470.5 1896.5,470.5 1874.5,470.5C 1874.23,468.901 1874.57,467.568 1875.5,466.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.626
    },
    fill: "#0067b1",
    d: "M 465.5,487.5 C 466.568,486.566 467.901,486.232 469.5,486.5C 469.831,508.34 469.497,530.006 468.5,551.5C 468.5,530.167 468.5,508.833 468.5,487.5C 467.5,487.5 466.5,487.5 465.5,487.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.512
    },
    fill: "#0066af",
    d: "M 3556.5,487.5 C 3557.57,486.566 3558.9,486.232 3560.5,486.5C 3560.83,508.34 3560.5,530.006 3559.5,551.5C 3559.5,530.167 3559.5,508.833 3559.5,487.5C 3558.5,487.5 3557.5,487.5 3556.5,487.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.553
    },
    fill: "#0f7bbc",
    d: "M 343.5,491.5 C 342.581,494.089 340.914,496.089 338.5,497.5C 339.419,494.911 341.086,492.911 343.5,491.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.558
    },
    fill: "#0066b0",
    d: "M 1005.5,517.5 C 1004.54,518.962 1003.38,520.295 1002,521.5C 1001.5,555.832 1001.33,590.165 1001.5,624.5C 970.329,624.831 939.329,624.498 908.5,623.5C 939.167,623.5 969.833,623.5 1000.5,623.5C 1000.33,589.165 1000.5,554.832 1001,520.5C 1002.33,519.167 1003.67,517.833 1005,516.5C 1005.4,516.728 1005.57,517.062 1005.5,517.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.58
    },
    fill: "#066aae",
    d: "M 191.5,527.5 C 190.306,531.363 187.973,534.363 184.5,536.5C 186.458,533.208 188.791,530.208 191.5,527.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.479
    },
    fill: "#0369b0",
    d: "M 2696.5,537.5 C 2695.79,541.933 2693.79,545.6 2690.5,548.5C 2692.25,544.665 2694.25,540.999 2696.5,537.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.619
    },
    fill: "#0067b2",
    d: "M 1860.5,542.5 C 1876,541.833 1891.66,541.5 1907.5,541.5C 1923.51,541.501 1939.18,542.167 1954.5,543.5C 1923.24,542.508 1891.91,542.175 1860.5,542.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.461
    },
    fill: "#0066b0",
    d: "M 3158.5,549.5 C 3160.96,552.751 3162.62,556.418 3163.5,560.5C 3161.04,557.249 3159.38,553.582 3158.5,549.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.671
    },
    fill: "#016cb3",
    d: "M 468.5,551.5 C 466.5,555.5 463.5,558.5 459.5,560.5C 462.167,557.167 465.167,554.167 468.5,551.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.892
    },
    fill: "#e31735",
    d: "M 4448.5,570.5 C 4469.88,572.704 4479.05,584.37 4476,605.5C 4469.88,619.813 4459.05,625.647 4443.5,623C 4430.3,619.458 4423.3,610.791 4422.5,597C 4424.67,581.665 4433.34,572.832 4448.5,570.5 Z M 4463.5,612.5 C 4452.63,619.831 4442.46,618.831 4433,609.5C 4425.04,591.753 4430.71,580.753 4450,576.5C 4469.29,580.753 4474.96,591.753 4467,609.5C 4465.96,610.71 4464.79,611.71 4463.5,612.5 Z M 4444.5,586.5 C 4448.18,586.335 4451.85,586.501 4455.5,587C 4459.5,589.333 4459.5,591.667 4455.5,594C 4451.85,594.499 4448.18,594.665 4444.5,594.5C 4445.37,591.938 4445.37,589.272 4444.5,586.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.847
    },
    fill: "#e31735",
    d: "M 4463.5,612.5 C 4461.4,612.799 4459.4,612.466 4457.5,611.5C 4454.75,607.668 4452.25,603.668 4450,599.5C 4448.3,598.594 4446.47,598.261 4444.5,598.5C 4444.5,603.167 4444.5,607.833 4444.5,612.5C 4442.83,612.5 4441.17,612.5 4439.5,612.5C 4439.5,602.5 4439.5,592.5 4439.5,582.5C 4446.17,582.334 4452.84,582.5 4459.5,583C 4464.31,586.089 4465.47,590.256 4463,595.5C 4460.96,597.604 4458.46,598.771 4455.5,599C 4458.82,603.143 4461.49,607.643 4463.5,612.5 Z M 4444.5,586.5 C 4445.37,589.272 4445.37,591.938 4444.5,594.5C 4448.18,594.665 4451.85,594.499 4455.5,594C 4459.5,591.667 4459.5,589.333 4455.5,587C 4451.85,586.501 4448.18,586.335 4444.5,586.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.426
    },
    fill: "#0067b2",
    d: "M 3183.5,590.5 C 3187.83,594.167 3191.83,598.167 3195.5,602.5C 3190.5,599.5 3186.5,595.5 3183.5,590.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.451
    },
    fill: "#0268b1",
    d: "M 2739.5,590.5 C 2736.11,594.898 2732.11,598.564 2727.5,601.5C 2730.89,597.102 2734.89,593.436 2739.5,590.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.497
    },
    fill: "#0067b0",
    d: "M 3360.5,595.5 C 3358.17,599.833 3354.83,603.167 3350.5,605.5C 3353.5,601.833 3356.83,598.5 3360.5,595.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.489
    },
    fill: "#0067b1",
    d: "M 1427.5,612.5 C 1423.65,615.593 1419.32,617.926 1414.5,619.5C 1418.35,616.407 1422.68,614.074 1427.5,612.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.504
    },
    fill: "#145d94",
    d: "M 2709.5,614.5 C 2708.09,616.539 2706.09,617.539 2703.5,617.5C 2705.18,615.992 2707.18,614.992 2709.5,614.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.612
    },
    fill: "#0067b1",
    d: "M 1160.5,619.5 C 1161.93,620.78 1162.6,622.447 1162.5,624.5C 1130.17,624.5 1097.83,624.5 1065.5,624.5C 1065.5,623.5 1065.5,622.5 1065.5,621.5C 1081.45,622.819 1097.61,623.485 1114,623.5C 1129.83,623.333 1145.67,623.167 1161.5,623C 1160.66,621.989 1160.33,620.822 1160.5,619.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.609
    },
    fill: "#0067b1",
    d: "M 1754.5,620.5 C 1754.5,621.5 1754.5,622.5 1754.5,623.5C 1783.83,623.5 1813.17,623.5 1842.5,623.5C 1842.26,622.209 1842.6,621.209 1843.5,620.5C 1843.5,621.833 1843.5,623.167 1843.5,624.5C 1813.5,624.5 1783.5,624.5 1753.5,624.5C 1753.23,622.901 1753.57,621.568 1754.5,620.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.608
    },
    fill: "#0066b1",
    d: "M 1969.5,620.5 C 1970.4,621.209 1970.74,622.209 1970.5,623.5C 2003.85,624.16 2036.85,623.493 2069.5,621.5C 2070.4,622.209 2070.74,623.209 2070.5,624.5C 2036.83,624.5 2003.17,624.5 1969.5,624.5C 1969.5,623.167 1969.5,621.833 1969.5,620.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.621
    },
    fill: "#0066b1",
    d: "M 568.5,622.5 C 569.289,622.783 569.956,623.283 570.5,624C 538.331,624.831 506.331,624.664 474.5,623.5C 506.004,623.832 537.338,623.498 568.5,622.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.621
    },
    fill: "#0067b2",
    d: "M 3659.5,622.5 C 3660.29,622.783 3660.96,623.283 3661.5,624C 3629.33,624.831 3597.33,624.664 3565.5,623.5C 3597,623.832 3628.34,623.498 3659.5,622.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoa1);
export default __webpack_public_path__ + "static/media/BOA1.907ff3b6549d452b2afd97b28286ff67.svg";
export { ForwardRef as ReactComponent };